import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  collection,
  getDocs,
  query,
} from 'firebase/firestore'
import FirebaseApp from './firebase'

const db = getFirestore(FirebaseApp)

/**
 * Получает один документ из коллекции.
 * @param {string} collectionPath - Путь к коллекции (например, 'masters').
 * @param {string} docId - ID документа.
 * @returns {Promise<object|null>} Данные документа с его ID, или null, если не найден.
 */
export const getDocument = async (collectionPath, docId) => {
  const docRef = doc(db, collectionPath, docId)
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() }
  } else {
    console.warn(`Документ не найден по пути: ${collectionPath}/${docId}`)
    return null
  }
}

/**
 * Создает или перезаписывает документ.
 * @param {string} collectionPath - Путь к коллекции.
 * @param {string} docId - ID документа для создания/перезаписи.
 * @param {object} data - Данные для записи.
 * @returns {Promise<void>}
 */
export const setDocument = (collectionPath, docId, data) => {
  const docRef = doc(db, collectionPath, docId)
  // { merge: true } предотвращает случайное удаление полей, которых нет в объекте `data`
  return setDoc(docRef, data, { merge: true })
}

/**
 * Обновляет существующий документ.
 * @param {string} collectionPath - Путь к коллекции.
 * @param {string} docId - ID документа для обновления.
 * @param {object} data - Поля для обновления.
 * @returns {Promise<void>}
 */
export const updateDocument = (collectionPath, docId, data) => {
  const docRef = doc(db, collectionPath, docId)
  return updateDoc(docRef, data)
}

/**
 * Получает все документы из коллекции или подколлекции.
 * @param {string[]} pathSegments - Сегменты пути (например, ['masters', masterId, 'services']).
 * @returns {Promise<object[]>} Массив документов, каждый с полем id.
 */
export const getCollection = async (pathSegments) => {
  // Проверяем, что в пути нечетное количество сегментов (путь к коллекции)
  if (pathSegments.length % 2 === 0) {
    throw new Error(
      'Неверный путь к коллекции. Путь должен содержать нечетное количество сегментов.',
    )
  }
  const collectionRef = collection(db, ...pathSegments)
  const q = query(collectionRef) // В будущем можно будет добавлять сюда фильтры
  const querySnapshot = await getDocs(q)
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
}
